import type { FindexUser } from '@/types/models/user'

export const checkEmailVerified = (user: FindexUser | undefined | null) => {
  const router = useRouter();

  
  const route = router.currentRoute.value;
  if (
    user &&
    user.emailVerified !== true &&
    !window.location.href.includes('/auth') &&
    !route.path.includes('/auth')
  ) {

    router.push('/auth/verifyEmail')
  }
}
